jQuery.fn.topBar = function () {
	return this.each(function () {
		const element = jQuery(this);

		if ('undefined' !== typeof setWithExpiry) {
			const topbar = getWithExpiry('topbar');
			if (null == topbar) {
				jQuery('body').addClass('have-topbar');
				element.show();
			} else {
				jQuery('body').removeClass('have-topbar');
				element.hide();
				element.height(0);
			}
		} else {
			console.log(
				'Please add the local-data dependency for the code to work fully -> topbar lib'
			);
		}

		element.find('.top-bar-cross').click(function () {
			jQuery(this).parents().find('body').addClass('hide-topbar');
			jQuery(this).parents().find('body').removeClass('have-topbar');
			if ('undefined' !== typeof setWithExpiry) {
				setWithExpiry('topbar', 'closed', 0, 86400 * 60 * 24); // 1 Day
			}
		});
		function getWithExpiry(key) {
			const itemStr = localStorage.getItem(key);
			if (!itemStr) {
				return null;
			}
			const item = JSON.parse(itemStr);
			const now = new Date();
			if (now.getTime() > item.expiry) {
				localStorage.removeItem(key);
				return null;
			}
			return item;
		}
		function setWithExpiry(key, value, discount = 0, ttl) {
			const now = new Date();
			const item = {
				value,
				discount,
				expiry: now.getTime() + ttl,
			};
			localStorage.setItem(key, JSON.stringify(item));
		}
	});
};
